import { ROUTES } from '../../../routes/config';

export const contents = [
  {
    title: 'WEB OTP',
    path: ROUTES.WebOTP,
  },
  {
    title: 'Draggable Rect',
    path: ROUTES.DraggableRect,
  },
  {
    title: 'Map Leaflet',
    path: ROUTES.MapLeaflet,
  },
  {
    title: 'Map Google',
    path: ROUTES.MapGoogle,
  }
];
